import { useGetQuoteFinali } from 'features/ippica/hooks';
import styles from './IppicaQuoteFinali.module.scss';
import { IppicaQuoteFinaliResultsContainer } from '../../ippicaQuoteFinaliResultsContainer/IppicaQuoteFinaliResultsContainer';
import { useTypedSelector } from 'lib/centralStore';
import { useMemo } from 'react';
import { selectQuoteFinali } from 'features/ippica/selectors';
export type IppicaQuoteFinaliProps = {
  title: string;
  hasMarginRight?: boolean;
};

export const IppicaQuoteFinali = ({ title, hasMarginRight }: IppicaQuoteFinaliProps) => {
  useGetQuoteFinali();
  const quoteFinali = useTypedSelector(selectQuoteFinali);
  const quoteFinaliKeys = useMemo(() => Object.keys(quoteFinali ?? {}), [quoteFinali]);

  return (
    !!quoteFinaliKeys.length && (
      <div className={`${styles.container} ${hasMarginRight ? styles.withMarginRight : ''}`}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.wrapperQuote}>
          {quoteFinaliKeys.map((codiceTipoScommessa) => (
            <IppicaQuoteFinaliResultsContainer key={codiceTipoScommessa} codiceTipoScommessa={+codiceTipoScommessa} />
          ))}
        </div>
      </div>
    )
  );
};
